module.exports = __webpack_public_path__ + "static/media/spoonerism-task (9).ecf3ed03.mp3";